namespace Areas.Workflows {
    "use strict";

    let selected: Selected = new Selected();
    let selectedDetail: Selected = new Selected();

    export function onUserIDValueChanged(rowData, value) {
        return userValueChanged(selected)(rowData, value);
    }

    export function onUserIDValueChangedDetail(rowData, value) {
        return userValueChanged(selectedDetail)(rowData, value);
    }

    export function userLookupEditTemplate(cellElement, cellInfo) {
        return lookupEditTemplate("/Workflows/WorkflowAuthUser/Users", selected)(cellElement, cellInfo);
    }

    export function userLookupEditTemplateDetail(cellElement, cellInfo) {
        return lookupEditTemplate("/Workflows/WorkflowDetail/Users", selectedDetail)(cellElement, cellInfo);
    }

    export function userLookupCellTemplate(cellElement, cellInfo) {
        return lookupCellTemplate(cellElement, cellInfo);
    }

    export function fillId(e) {
        const dataGrid = Areas.getGrid("WorkflowAuthUserGrid");
        const workflowId = dataGrid.option('WorkflowId');

        e.data.workflowId = workflowId;
        e.data.editRights = false;
        e.data.ccEmail = false;
        e.data.isActive = true;
    }

    export function workflowDetailAssignWorkflowId(e) {
        const dataGrid = e.component;
        const workflowId = dataGrid.option('KeyId');

        e.data.workflowId = workflowId;
    }

    export function showCollaborationAreaLookup() {
        const collaborationAreaLookupDialog =
            new Areas.Dialogs.CollaborationAreaLookup.CollaborationAreaLookupDialog(collaborationAreaLookupDialogClosing);
    }

    function collaborationAreaLookupDialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const CollaborationAreaId = data.collaborationAreaId;
        const newName = data.name;
        const projectName = data.projectName;
        const projectNumber = data.projectNumber;
        
        //this is the lookup form _CollaborationAreaLookupForm
        const lookupForm: DevExpress.ui.dxForm = Areas.getForm("CollaborationAreaLookupForm");
        const lookupData: any = lookupForm.option('formData');

        lookupData.CollaborationAreaName = newName;
        lookupData.ProjectName = projectName;
        lookupData.ProjectNumber = projectNumber;

        const lunumberControl: DevExpress.ui.dxTextBox = lookupForm
            .getEditor('ProjectNumber') as DevExpress.ui.dxTextBox;
        lunumberControl.option("value", projectNumber);

        const lunameControl: DevExpress.ui.dxTextBox = lookupForm
            .getEditor('ProjectName') as DevExpress.ui.dxTextBox;
        lunameControl.option("value", projectName);

        const luareaControl: DevExpress.ui.dxTextBox = lookupForm
            .getEditor('CollaborationAreaName') as DevExpress.ui.dxTextBox;
        luareaControl.option("value", newName);


        //this is the main form _DataForm.cshtml
        const dataForm: DevExpress.ui.dxForm = Areas.getForm("WorkflowsForm");
        const newData: any = dataForm.option('formData');

        newData.CollaborationAreaId = CollaborationAreaId;
        
        const areaControl: DevExpress.ui.dxTextBox = dataForm.getEditor('CollaborationAreaId') as DevExpress.ui.dxTextBox;
        areaControl.option("value", CollaborationAreaId);
    }
}